import "./TestimonyCard.css";

export default function TestimonyCard({ item }) {
  return (
    <div className="testimony-card">
      <span
        style={{
          color: "#F4CE14",
          fontSize: "1.2rem",
          marginBottom: "0.5rem",
        }}
        aria-label={`${item.rating} out of 5 stars`}
      >
        {Array.from({ length: 5 }, (_, index) => (
          <span key={index}>{index < item.rating ? "★" : "☆"}</span>
        ))}
      </span>
      <div className="testimony-header" style={{ paddingBottom: "1rem" }}>
        <img
          src={item.image}
          alt={item.alt}
          style={{
            width: "4rem",
            aspectRatio: "1 / 1",
            objectFit: "cover",
            marginBottom: "0.5rem",
          }}
        />
        <h4>{item.name}</h4>
      </div>

      <blockquote style={{ paddingBottom: "1rem" }}>
        <p>"{item.description}"</p>
      </blockquote>
    </div>
  );
}
